import { lazy } from "react"

export const RemoteViewIFrame = lazy(() => import("./remote-view"))
